module.exports = __webpack_public_path__ + "img/sb-active.08127845.png";